import React from 'react';
import { NewsItem } from '@/API/admin/news';

interface EditModalProps {
  isOpen: boolean;
  onClose: () => void;
  newsItem?: NewsItem; // オプショナルにする
}

export const EditNewsModal = ({
  isOpen,
  onClose,
  newsItem,
}: EditModalProps) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center">
      <div className="bg-white p-6 rounded w-2/3 max-w-lg">
        <h2 className="text-lg font-bold mb-4">
          {newsItem ? 'ニュースの編集' : 'ニュースの新規作成'}
        </h2>

        <form>
          <div className="mb-4">
            <label className="block text-sm font-medium">日付</label>
            <input
              type="date"
              className="border p-2 w-full"
              defaultValue={newsItem?.releaseDate || ''}
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium">種別</label>
            <input
              type="text"
              className="border p-2 w-full"
              defaultValue={newsItem?.tag || ''}
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium">タイトル</label>
            <input
              type="text"
              className="border p-2 w-full"
              defaultValue={newsItem?.title || ''}
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium">URL</label>
            <input
              type="text"
              className="border p-2 w-full"
              defaultValue={newsItem?.url || ''}
            />
          </div>

          <div className="mb-4">
            <label className="block text-sm font-medium">表示</label>
            <div className="flex items-center">
              <input
                type="radio"
                name="display"
                value="normal"
                className="mr-2"
                defaultChecked={!newsItem || newsItem.displayType === 'normal'}
              />
              <label className="mr-4">通常表示</label>

              <input
                type="radio"
                name="display"
                value="fixed"
                className="mr-2"
                defaultChecked={newsItem?.displayType === 'fixed'}
              />
              <label>トップ固定表示</label>
            </div>
          </div>

          <div className="flex justify-between">
            <button
              type="button"
              className="border border-black rounded px-4 py-2 text-black"
              onClick={onClose}
            >
              戻る
            </button>

            <button
              type="submit"
              className="bg-green-300 text-black rounded px-4 py-2"
            >
              {newsItem ? '更新' : '作成'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};
